@if (isCustomerBankIdVerified) {
  <app-ice-alert type="info">
    <div heading>Kunden er allerede verifisert</div>
  </app-ice-alert>
} @else {
  <div [class]="'container' + (!shouldUsePadding() ? ' no-padding' : '')">
    <div class="input-container">
      @if (shouldShowRequiredAlert()) {
        <app-ice-alert animate.close="close-animation" class="required-alert" type="error">
          <div heading>BankID kreves</div>
          <div>
            Tast inn {{ bankIdVerificationDeliveryMethod }} for å motta BankID-forespørsel for å fortsette bestillingen.
          </div>
        </app-ice-alert>
      }
      <form class="bankid-input-form" [formGroup]="bankIdVerificationForm" (ngSubmit)="onSubmit()">
        <mat-button-toggle-group
          class="bankid-delivery-toggle-group"
          formControlName="bankIdVerificationDeliveryMethod"
          hideSingleSelectionIndicator
        >
          <mat-button-toggle [value]="BankIdVerificationDeliveryMethod.SMS">SMS</mat-button-toggle>
          <mat-button-toggle [value]="BankIdVerificationDeliveryMethod.Email">E-post</mat-button-toggle>
        </mat-button-toggle-group>
        <div class="bankid-input-row">
          @if (
            bankIdVerificationForm.controls.bankIdVerificationDeliveryMethod.value === BankIdVerificationDeliveryMethod.SMS
          ) {
            <app-ice-input-field
              formControlName="bankIdMsisdn"
              inputWidth="large"
              label="Tast inn mobilnummeret for BankID"
              ngDefaultControl
              placeholder="Telefonnummer"
              textTestId="bankid-msisdn-input"
            />
          } @else {
            <app-ice-input-field
              formControlName="bankIdEmail"
              inputWidth="large"
              label="Tast inn e-postadressen for BankID"
              ngDefaultControl
              placeholder="E-postadresse"
              textTestId="bankid-email-input"
            />
          }
          @if (showButton()) {
            <app-ice-button
              size="medium"
              testId="bankid-submit-button"
              type="submit"
              [disabled]="!bankIdVerificationForm.valid"
            >
              {{
                buttonText() ??
                  (bankIdVerificationForm.controls.bankIdVerificationDeliveryMethod.value ===
                  BankIdVerificationDeliveryMethod.SMS
                    ? 'Send SMS'
                    : 'Send e-post')
              }}
            </app-ice-button>
          }
        </div>
      </form>
    </div>
    @if (canBypassBankId() && displayBypassOption()) {
      <mat-checkbox
        data-testid="bypass-bankid-checkbox-input"
        [checked]="isBypassBankIdToggled"
        (change)="toggleBypassBankId($event)"
      >
        <span>Fortsett uten BankID</span>
      </mat-checkbox>
      @if (isBypassBankIdToggled) {
        <form class="bypass-bankid-form" [formGroup]="bypassBankIdForm">
          <div>
            <span>
              Du er fullt ansvarlig for å gjennomføre en korrekt manuell ID-kontroll og må ikke gå videre før legitimasjonen
              er verifisert uten tvil.
            </span>
            <app-ice-textarea
              errorText="Begrunnelsen kan maks være 255 tegn langt"
              formControlName="reasonNote"
              label=""
              longHelpText="Skriv kort hvorfor kunden ikke kan bruke BankID"
              ngDefaultControl
              testId="bankid-bypass-note"
              [errorOnTouchedOnly]="true"
            />
          </div>
        </form>
      }
    }
  </div>
}
